import { Button } from '@/ui/foundation/primitives/button.js';
import { Card, CardContent } from '@/ui/foundation/primitives/card.js';

interface SplashUiAppProps {
    busy: boolean;
    canLoad: boolean;
    onQuick: () => void;
    onLoad: () => void;
    onNew: () => void;
}

export function SplashUiApp({ busy, canLoad, onQuick, onLoad, onNew }: SplashUiAppProps) {
    return (
        <div className="dark absolute inset-0 z-50">
            <div className="absolute inset-0 bg-[url('/assets/background.jpg')] bg-cover bg-center bg-no-repeat" />
            <div className="absolute inset-0 bg-black/62 backdrop-blur-md" />
            <div className="relative flex min-h-dvh items-center justify-center px-6 py-10">
                <Card className="w-full max-w-md border-white/25 bg-background/85 shadow-2xl">
                    <CardContent className="flex flex-col items-center gap-6 px-6 py-10 text-center">
                        <div className="space-y-2">
                            <h1 className="text-4xl font-extrabold tracking-tight text-foreground">TeamSquad</h1>
                            <p className="text-sm text-muted-foreground">
                                A football management simulator in your browser.
                            </p>
                        </div>
                        <div className="flex w-full max-w-xs flex-col gap-3">
                            <Button size="lg" onClick={onQuick} disabled={busy}>
                                Play Quick Match
                            </Button>
                            <Button
                                size="lg"
                                className="bg-accent text-accent-foreground hover:bg-accent/80"
                                onClick={onLoad}
                                disabled={busy || !canLoad}
                            >
                                Continue Campaign
                            </Button>
                            <Button
                                size="lg"
                                variant="outline"
                                className="border-primary/45 bg-primary/12 text-primary hover:bg-primary/20"
                                onClick={onNew}
                                disabled={busy}
                            >
                                Start New Campaign
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
